import React, { useEffect, useState } from "react";
import { Col, Flex, Row } from "antd";
import { Widget } from "../../../../Atomics/Widget";
import { useTranslation } from "react-i18next";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from "clsx";
import { loaddiagramDummyData } from "../../../../../../utils/dummydata";
import { Text } from "../../../../Atomics/Text";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import logger from "../../../../../../server/server";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

export const BuildingEnergeticConsumptionDetail = ({
  building,
  currentFloor,
  ...props
}) => {
  const { t } = useTranslation();
  const {user,tenant} = useAuthContext();

  useEffect(() => {
    logger.info("User: " + user?.Username + " entered BuildingEnergeticConsumptionDetail successfully! Tenant: " + tenant);
  }, []);

  const [showActiveChart, setShowActiveChart] = useState(true);
  const [currentCPE, setCurrentCPE] = useState(null);

  return (
    <PageContent className={clsx("building_room_details", props?.className)}>
      <Row>
        <Col span={10}>
          <h3>
            {building?.name} | {t("Energetic Consumption").toLocaleUpperCase()}
          </h3>
        </Col>
        <Col span={4} offset={10}>
          <SelectAtomic
            optionsData={currentFloor?.cpes?.map((x) => {
              return { label: x.name, value: x.id };
            })}
            handleOptionsChange={(value, record) => {
              setCurrentCPE(value);
            }}
            defaultValue={currentCPE}
            fullWidth={true}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Top Energy"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Inductive Consumption"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Energy Produced"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Active Consumption"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Capacitive Consumption"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Grid Injection"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "60px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={16}>
          <Widget
            data={{
              background: "white",
              title: t("Load Diagram"),
              charts: [
                {
                  chartType: "mixedLineColumnChartApex",
                  chartId: "mixBarChartLineThree",
                  height: "330px",
                  data: loaddiagramDummyData(t),
                },
              ],
              dropdowns: [
                {
                  data: [
                    {
                      label: t("Active Power and Production Power"),
                      value: "Active Power and Production Power",
                    },
                    {
                      label: t("Inductive Power and Capacitive Power"),
                      value: "Inductive Power and Capacitive Power",
                    },
                  ],
                  value: showActiveChart,
                  functionChange: () => setShowActiveChart(!showActiveChart),
                  width: "300px",
                },
              ],
            }}
          />
        </Col>
      </Row>

      {/* 'Information From Previous Period' */}
      <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
        <Col span={24}>
          {/* //TODO: Translations */}
          <Text
            $fontColor="coolgray-12"
            $fontSize="text_xl"
            $weight="regular"
            $marginRight="s03"
          >
            {t("Information From Previous Period")}
          </Text>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Highest Registered Peak"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Inductive Consumption"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Active Consumption"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Capacitive Consumption"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={16}>
          <Widget
            data={{
              background: "white",
              title: t("Daily Power Peak"),
              charts: [
                {
                  chartType: "mixedLineColumnChartApex",
                  chartId: "mixBarChartLineThree",
                  height: "255px",
                  data: loaddiagramDummyData(t),
                },
              ],
              dropdowns: [
                {
                  data: [
                    { label: t("Active Power"), value: "Active Power" },
                    { label: t("Production Power"), value: "Production Power" },
                    { label: t("Reactive Power"), value: "Reactiva Power" },
                    { label: t("Inductive Power"), value: "Inductive Power" },
                  ],
                  value: showActiveChart,
                  functionChange: () => setShowActiveChart(!showActiveChart),
                  width: "200px",
                },
              ],
            }}
          />
        </Col>
      </Row>

      {/* 'Energy vs Production' */}
      <Row gutter={[16, 16]} style={{ marginTop: "40px" }}>
        <Col span={24}>
          {/* //TODO: Translations */}
          <Text
            $fontColor="coolgray-12"
            $fontSize="text_xl"
            $weight="regular"
            $marginRight="s03"
          >
            {t("Energy vs Production")}
          </Text>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Production Peak"), //TODO: Translations
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "110px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Energy Produced"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                background: "white",
                title: t("Accumulated Emissions Avoided"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
            <Widget
              data={{
                background: "white",
                title: t("Grid Injection"),
                charts: [
                  {
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    height: "90px",
                    data: { number: 0 },
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={16}>
          <Widget
            data={{
              background: "white",
              title: t("Energy"),
              charts: [
                {
                  chartType: "mixedLineColumnChartApex",
                  chartId: "mixBarChartLineThree",
                  height: "275px",
                  data: loaddiagramDummyData(t),
                },
              ],
            }}
          />
        </Col>
      </Row>
    </PageContent>
  );
};
